module.exports = __webpack_public_path__ + "img/walletc.180e7b31.svg";